import React from "react";

function SmallReportOption(props) {
  return (
    <div className="flex flex-col bg-bgwhite w-[100%]  rounded-2xl justify-start px-3 py-5 mb-3 pb-3 mr-3">
      <div className="flex ">
        {props.children && (
          <span className="mr-3 rounded-full bg-bgwhitegrey text-2xl p-2 text-btnbgcolor">
            {props.children}
          </span>
        )}
        <div className="flex flex-col">
          <span className="text-xs text-bgbluegrey">{props.title}</span>
          <div className="flex items-center">
            <span className=" text-sm lg:text-base font-bold ">
              {props.value}
            </span>
            {(props.percentage || props.time) && (
              <div className="text-xs ml-2">
                <span className="text-[0.5rem] xl:text-[0.6rem]  text-textgreen">
                  {props.percentage}
                </span>
                <span className="text-[0.5rem]  xl:text-[0.6rem] ml-1 text-bgbluegrey">
                  {props.time}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div></div>
    </div>
  );
}

export default SmallReportOption;
